<script lang="ts">
	import type { i18n } from 'types/common'

	import Icon from '@isoftdata/svelte-icon'
	import { getContext } from 'svelte'

	interface Props {
		value: boolean
	}

	let { value }: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')
</script>

<Icon
	fixedWidth
	icon={value ? 'check' : 'xmark-large'}
	class={value ? 'text-success' : 'text-danger'}
></Icon>
<span class="visually-hidden">{value ? translate('common:yes', 'Yes') : translate('common:no', 'No')}</span>
